import { z } from 'zod';

export const insurerAttentionCreateSchema = z.object({
  prefecture_id: z.string().min(1, '都道府県は必須です。'),
  publish_date: z.string().min(1, '掲載日は必須です。'),
  remarks: z
    .string()
    .trim()
    .min(1, '注意事項は必須です。')
    .max(500, '注意事項は500文字以下にしてください。'),
});

export type InsurerAttentionCreateFormData = z.infer<typeof insurerAttentionCreateSchema>;
